import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Grid, Link, Tabs, Button, Translation } from '../../common';
import {
  HOME,
  PAYMENTS,
  FEEDBACK,
  QUALTRICS_FEEDBACK,
} from '../../../constants/routes';

import { PAY_NOW_TEXT_KEY } from '../../../constants/payment';

import { connectTo } from '../../../utils';

import { ReactComponent as PhoneIcon } from '../../../assets/img/contacts/phone.svg';
import { ReactComponent as WhatsappIcon } from '../../../assets/img/contacts/whatsapp.svg';
import { ReactComponent as ChatIcon } from '../../../assets/img/contacts/chat.svg';
import { ReactComponent as EmailIcon } from '../../../assets/img/contacts/email.svg';
import { ReactComponent as TwitterIcon } from '../../../assets/img/contacts/twitter.svg';

const ContactsContent = ({ styles, translations, fullWidth, mobile }) => {
  const contacts = [
    {
      label: 'TROY_PHONE',
      icon: <PhoneIcon />,
      link: `tel:${translations['TROY_PHONE']}`,
      id: 'page.component.home-container.contact-phone',
    },
    {
      label: 'Whatsapp',
      icon: <WhatsappIcon />,
      link: `https://wa.me/${translations['TROY_WHATSAPP']}`,
      id: 'page.component.home-container.contact-whatsapp',
    },
    {
      label: 'SMS',
      icon: <ChatIcon />,
      link: `sms:${translations['TROY_SMS']}`,
      id: 'page.component.home-container.contact-chat',
    },
    {
      label: 'E-Mail',
      icon: <EmailIcon />,
      link: `mailto:${translations['TROY_EMAIL']}`,
      id: 'page.component.home-container.contact-email',
    },
    {
      label: 'Twitter',
      icon: <TwitterIcon />,
      link: translations['TROY_TWITTER'],
      id: 'page.component.home-container.contact-twitter',
    },
  ];

  return (
    <Grid
      container
      className={
        styles[`contacts__content${mobile ? '_mobile-only' : '_desktop-only'}`]
      }
    >
      {contacts &&
        contacts.length &&
        contacts.map(({ label, icon, link, mobile, id }, idx) => (
          <Grid
            item
            xs={fullWidth}
            className={
              styles[`contacts__contact${mobile ? '_mobile-only' : ''}`]
            }
            key={idx}
          >
            <Link
              raw
              id={`${id}-link`}
              className={styles['contacts__link']}
              to={link ? link : '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                id={`${id}-button`}
                fullWidth={true}
                variant="text"
                className={styles['contacts__contact-button']}
              >
                <div className={styles['contacts__contact-icon']}>{icon}</div>
                <Translation
                  keyIfNoValue
                  className={styles['contacts__contact-label']}
                >
                  {label}
                </Translation>
              </Button>
            </Link>
          </Grid>
        ))}
    </Grid>
  );
};

const Contacts = connectTo(
  ({ translations: { translations } }) => ({ translations }),
  {},
  ContactsContent
);

const HeaderTabs = ({ styles, mobile, value, onTabChange, tabs }) => (
  <Tabs
    className={
      styles[`header__tabs${mobile ? '_mobile-only' : '_desktop-only'}`]
    }
    tabClassName={styles['header__tab']}
    flexContainerClassName={styles['header__tabs-flex-container']}
    labelClassName={styles['header__tab-label']}
    iconClassName={styles['header__tab-icon']}
    indicatorClassName={styles['header__tab-selected-indicator']}
    selectedClassName={styles['header__tab-selected']}
    value={
      (value || value === 0) &&
      (tabs || []).find(({ value: tabValue }) => tabValue === value)
        ? value
        : false
    }
    onChange={onTabChange}
    options={tabs}
    translated
    isMobile={mobile}
  />
);

const HeaderWithContacts = React.forwardRef(
  (
    {
      styles,
      onLogoClick,
      Logo,
      value,
      onTabChange,
      tabs,
      mobileTabs,
      contacts,
      isSticky,
      currentRoute,
    },
    ref
  ) => (
    <div
      ref={ref}
      className={classNames(
        styles['header-with-contacts__wrapper'],
        isSticky ? styles['sticky'] : ''
      )}
    >
      <div className={styles['header-with-contacts']}>
        <div className={styles['header']}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={styles['header-with-contacts__content']}
          >
            <Grid item className={styles['header-with-contacts__logo-wrapper']}>
              <Link
                id="page.component.home-header.logo-link"
                to={HOME}
                onClick={onLogoClick}
              >
                <Logo />
              </Link>
            </Grid>
            <Grid item>
              <HeaderTabs {...{ styles, value, onTabChange, tabs }} />
              <Contacts mobile {...{ styles, contacts }} />
            </Grid>
          </Grid>
        </div>
        <div className={styles['contacts']}>
          <Contacts {...{ styles, contacts }} fullWidth />
          <HeaderTabs
            {...{ styles, value, onTabChange }}
            tabs={mobileTabs}
            mobile
          />
        </div>
      </div>
      {isSticky &&
      currentRoute !== PAYMENTS &&
      currentRoute !== FEEDBACK &&
      currentRoute !== QUALTRICS_FEEDBACK ? (
        <div className={styles['header-with-contacts__pay-now-wrapper']}>
          <Link id="page.component.home-header.pay-now-link" to={PAYMENTS}>
            <Button
              id="page.component.home-container.pay-now-button"
              fullWidth
              className={styles['header-with-contacts__pay-now']}
            >
              <Translation>{PAY_NOW_TEXT_KEY}</Translation>
            </Button>
          </Link>
        </div>
      ) : null}
    </div>
  )
);

HeaderWithContacts.propTypes = {
  styles: PropTypes.object,
  onLogoClick: PropTypes.func,
  Logo: PropTypes.any,
  hideHeader: PropTypes.bool,
  value: PropTypes.any,
  onTabChange: PropTypes.func,
  tabs: PropTypes.array,
  mobileTabs: PropTypes.array,
  contacts: PropTypes.array,
};

export default HeaderWithContacts;
